/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OEX API
 * Operators Exchange REST API (docs/08). Org-scoped routes take the active organisation in X-Org-Id; errors are RFC 7807 problem details with a `code`.
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminFileListDto,
  CreateUploadDto,
  FileDto,
  FileListDto,
  FilesAdminListParams,
  FilesDownloadParams,
  FilesListOrgFilesParams,
  UploadIntentDto
} from '../../model';

import { oexFetch } from '../../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getFilesAdminListUrl = (params?: FilesAdminListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/files?${stringifiedParams}` : `/v1/admin/files`
}

export const filesAdminList = async (params?: FilesAdminListParams, options?: Parameters<typeof oexFetch>[1]): Promise<AdminFileListDto> => {

  return oexFetch<AdminFileListDto>(getFilesAdminListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilesAdminListQueryKey = (params?: FilesAdminListParams,) => {
    return [
    `/v1/admin/files`, ...(params ? [params] : [])
    ] as const;
    }


export const getFilesAdminListQueryOptions = <TData = Awaited<ReturnType<typeof filesAdminList>>, TError = unknown>(params?: FilesAdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminList>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilesAdminListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filesAdminList>>> = ({ signal }) => filesAdminList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filesAdminList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilesAdminListQueryResult = NonNullable<Awaited<ReturnType<typeof filesAdminList>>>
export type FilesAdminListQueryError = unknown


export function useFilesAdminList<TData = Awaited<ReturnType<typeof filesAdminList>>, TError = unknown>(
 params: undefined |  FilesAdminListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesAdminList>>,
          TError,
          Awaited<ReturnType<typeof filesAdminList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesAdminList<TData = Awaited<ReturnType<typeof filesAdminList>>, TError = unknown>(
 params?: FilesAdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesAdminList>>,
          TError,
          Awaited<ReturnType<typeof filesAdminList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesAdminList<TData = Awaited<ReturnType<typeof filesAdminList>>, TError = unknown>(
 params?: FilesAdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminList>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFilesAdminList<TData = Awaited<ReturnType<typeof filesAdminList>>, TError = unknown>(
 params?: FilesAdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminList>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilesAdminListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilesAdminDownloadUrl = (id: string,) => {




  return `/v1/admin/files/${id}/download`
}

/**
 * @summary Staff download; requires X-Reason, audited
 */
export const filesAdminDownload = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<unknown> => {

  return oexFetch<unknown>(getFilesAdminDownloadUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilesAdminDownloadQueryKey = (id: string,) => {
    return [
    `/v1/admin/files/${id}/download`
    ] as const;
    }


export const getFilesAdminDownloadQueryOptions = <TData = Awaited<ReturnType<typeof filesAdminDownload>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminDownload>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilesAdminDownloadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filesAdminDownload>>> = ({ signal }) => filesAdminDownload(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filesAdminDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilesAdminDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof filesAdminDownload>>>
export type FilesAdminDownloadQueryError = void


export function useFilesAdminDownload<TData = Awaited<ReturnType<typeof filesAdminDownload>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesAdminDownload>>,
          TError,
          Awaited<ReturnType<typeof filesAdminDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesAdminDownload<TData = Awaited<ReturnType<typeof filesAdminDownload>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesAdminDownload>>,
          TError,
          Awaited<ReturnType<typeof filesAdminDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesAdminDownload<TData = Awaited<ReturnType<typeof filesAdminDownload>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminDownload>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Staff download; requires X-Reason, audited
 */

export function useFilesAdminDownload<TData = Awaited<ReturnType<typeof filesAdminDownload>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesAdminDownload>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilesAdminDownloadQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilesCreateUploadUrl = () => {




  return `/v1/files`
}

/**
 * @summary Upload intent: a signed PUT URL bound to type and size (15 min)
 */
export const filesCreateUpload = async (createUploadDto: CreateUploadDto, options?: Parameters<typeof oexFetch>[1]): Promise<UploadIntentDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<UploadIntentDto>(getFilesCreateUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUploadDto)
  }
);}





export const getFilesCreateUploadMutationKey = () => ['filesCreateUpload'] as const;

export const getFilesCreateUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filesCreateUpload>>, TError,FilesCreateUploadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof filesCreateUpload>>, TError,FilesCreateUploadMutationVariables, TContext> => {

const mutationKey = getFilesCreateUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filesCreateUpload>>, FilesCreateUploadMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  filesCreateUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FilesCreateUploadMutationResult = NonNullable<Awaited<ReturnType<typeof filesCreateUpload>>>
    export type FilesCreateUploadMutationBody = CreateUploadDto
    export type FilesCreateUploadMutationError = unknown
    export type FilesCreateUploadMutationVariables = {data: CreateUploadDto}

    /**
 * @summary Upload intent: a signed PUT URL bound to type and size (15 min)
 */
export const useFilesCreateUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filesCreateUpload>>, TError,FilesCreateUploadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filesCreateUpload>>,
        TError,
        FilesCreateUploadMutationVariables,
        TContext
      > => {
      return useMutation(getFilesCreateUploadMutationOptions(options), queryClient);
    }
    export const getFilesListOrgFilesUrl = (params?: FilesListOrgFilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/files?${stringifiedParams}` : `/v1/files`
}

export const filesListOrgFiles = async (params?: FilesListOrgFilesParams, options?: Parameters<typeof oexFetch>[1]): Promise<FileListDto> => {

  return oexFetch<FileListDto>(getFilesListOrgFilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilesListOrgFilesQueryKey = (params?: FilesListOrgFilesParams,) => {
    return [
    `/v1/files`, ...(params ? [params] : [])
    ] as const;
    }


export const getFilesListOrgFilesQueryOptions = <TData = Awaited<ReturnType<typeof filesListOrgFiles>>, TError = unknown>(params?: FilesListOrgFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesListOrgFiles>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilesListOrgFilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filesListOrgFiles>>> = ({ signal }) => filesListOrgFiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filesListOrgFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilesListOrgFilesQueryResult = NonNullable<Awaited<ReturnType<typeof filesListOrgFiles>>>
export type FilesListOrgFilesQueryError = unknown


export function useFilesListOrgFiles<TData = Awaited<ReturnType<typeof filesListOrgFiles>>, TError = unknown>(
 params: undefined |  FilesListOrgFilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesListOrgFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesListOrgFiles>>,
          TError,
          Awaited<ReturnType<typeof filesListOrgFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesListOrgFiles<TData = Awaited<ReturnType<typeof filesListOrgFiles>>, TError = unknown>(
 params?: FilesListOrgFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesListOrgFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesListOrgFiles>>,
          TError,
          Awaited<ReturnType<typeof filesListOrgFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesListOrgFiles<TData = Awaited<ReturnType<typeof filesListOrgFiles>>, TError = unknown>(
 params?: FilesListOrgFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesListOrgFiles>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFilesListOrgFiles<TData = Awaited<ReturnType<typeof filesListOrgFiles>>, TError = unknown>(
 params?: FilesListOrgFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesListOrgFiles>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilesListOrgFilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilesGetFileUrl = (id: string,) => {




  return `/v1/files/${id}`
}

export const filesGetFile = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<FileDto> => {

  return oexFetch<FileDto>(getFilesGetFileUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilesGetFileQueryKey = (id: string,) => {
    return [
    `/v1/files/${id}`
    ] as const;
    }


export const getFilesGetFileQueryOptions = <TData = Awaited<ReturnType<typeof filesGetFile>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesGetFile>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilesGetFileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filesGetFile>>> = ({ signal }) => filesGetFile(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filesGetFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilesGetFileQueryResult = NonNullable<Awaited<ReturnType<typeof filesGetFile>>>
export type FilesGetFileQueryError = unknown


export function useFilesGetFile<TData = Awaited<ReturnType<typeof filesGetFile>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesGetFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesGetFile>>,
          TError,
          Awaited<ReturnType<typeof filesGetFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesGetFile<TData = Awaited<ReturnType<typeof filesGetFile>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesGetFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesGetFile>>,
          TError,
          Awaited<ReturnType<typeof filesGetFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesGetFile<TData = Awaited<ReturnType<typeof filesGetFile>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesGetFile>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFilesGetFile<TData = Awaited<ReturnType<typeof filesGetFile>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesGetFile>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilesGetFileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFilesDeleteFileUrl = (id: string,) => {




  return `/v1/files/${id}`
}

/**
 * @summary Delete an unattached file (retained files: 422)
 */
export const filesDeleteFile = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<FileDto> => {

  return oexFetch<FileDto>(getFilesDeleteFileUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getFilesDeleteFileMutationKey = () => ['filesDeleteFile'] as const;

export const getFilesDeleteFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filesDeleteFile>>, TError,FilesDeleteFileMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof filesDeleteFile>>, TError,FilesDeleteFileMutationVariables, TContext> => {

const mutationKey = getFilesDeleteFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filesDeleteFile>>, FilesDeleteFileMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  filesDeleteFile(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FilesDeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof filesDeleteFile>>>

    export type FilesDeleteFileMutationError = unknown
    export type FilesDeleteFileMutationVariables = {id: string}

    /**
 * @summary Delete an unattached file (retained files: 422)
 */
export const useFilesDeleteFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filesDeleteFile>>, TError,FilesDeleteFileMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filesDeleteFile>>,
        TError,
        FilesDeleteFileMutationVariables,
        TContext
      > => {
      return useMutation(getFilesDeleteFileMutationOptions(options), queryClient);
    }
    export const getFilesCompleteUploadUrl = (id: string,) => {




  return `/v1/files/${id}/complete`
}

/**
 * @summary Verify the uploaded object and mark the file ready
 */
export const filesCompleteUpload = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<FileDto> => {

  return oexFetch<FileDto>(getFilesCompleteUploadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFilesCompleteUploadMutationKey = () => ['filesCompleteUpload'] as const;

export const getFilesCompleteUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filesCompleteUpload>>, TError,FilesCompleteUploadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof filesCompleteUpload>>, TError,FilesCompleteUploadMutationVariables, TContext> => {

const mutationKey = getFilesCompleteUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filesCompleteUpload>>, FilesCompleteUploadMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  filesCompleteUpload(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FilesCompleteUploadMutationResult = NonNullable<Awaited<ReturnType<typeof filesCompleteUpload>>>

    export type FilesCompleteUploadMutationError = unknown
    export type FilesCompleteUploadMutationVariables = {id: string}

    /**
 * @summary Verify the uploaded object and mark the file ready
 */
export const useFilesCompleteUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filesCompleteUpload>>, TError,FilesCompleteUploadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filesCompleteUpload>>,
        TError,
        FilesCompleteUploadMutationVariables,
        TContext
      > => {
      return useMutation(getFilesCompleteUploadMutationOptions(options), queryClient);
    }
    export const getFilesDownloadUrl = (id: string,
    params?: FilesDownloadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/files/${id}/download?${stringifiedParams}` : `/v1/files/${id}/download`
}

/**
 * @summary 302 to a signed URL valid for 5 minutes
 */
export const filesDownload = async (id: string,
    params?: FilesDownloadParams, options?: Parameters<typeof oexFetch>[1]): Promise<unknown> => {

  return oexFetch<unknown>(getFilesDownloadUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFilesDownloadQueryKey = (id: string,
    params?: FilesDownloadParams,) => {
    return [
    `/v1/files/${id}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getFilesDownloadQueryOptions = <TData = Awaited<ReturnType<typeof filesDownload>>, TError = void>(id: string,
    params?: FilesDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesDownload>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilesDownloadQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filesDownload>>> = ({ signal }) => filesDownload(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filesDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilesDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof filesDownload>>>
export type FilesDownloadQueryError = void


export function useFilesDownload<TData = Awaited<ReturnType<typeof filesDownload>>, TError = void>(
 id: string,
    params: undefined |  FilesDownloadParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesDownload>>,
          TError,
          Awaited<ReturnType<typeof filesDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesDownload<TData = Awaited<ReturnType<typeof filesDownload>>, TError = void>(
 id: string,
    params?: FilesDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filesDownload>>,
          TError,
          Awaited<ReturnType<typeof filesDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilesDownload<TData = Awaited<ReturnType<typeof filesDownload>>, TError = void>(
 id: string,
    params?: FilesDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesDownload>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 302 to a signed URL valid for 5 minutes
 */

export function useFilesDownload<TData = Awaited<ReturnType<typeof filesDownload>>, TError = void>(
 id: string,
    params?: FilesDownloadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filesDownload>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilesDownloadQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






